import React from 'react';

const SiteMap = () => {
    // Styles Object (Matching your Terms and Privacy pages)
    const styles = {
        pageContainer: {
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#f8fafc',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#334155',
            lineHeight: '1.6',
        },
        headerBanner: {
            position: 'relative',
            padding: '60px 20px',
            background: 'linear-gradient(135deg, #BD06D3 0%, #00BFFF 100%)',
            color: '#ffffff',
            textAlign: 'center',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        },
        bannerContent: {
            maxWidth: '800px',
            margin: '0 auto',
        },
        mainTitle: {
            fontSize: '2.5rem',
            fontWeight: '800',
            marginBottom: '8px',
            color: '#ffffff',
        },
        subTitle: {
            fontSize: '1.2rem',
            fontWeight: '500',
            opacity: '0.95',
        },
        wrapper: {
            maxWidth: '1440px',
            margin: '0 auto',
            padding: '40px 20px',
        },
        gridContainer: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '30px',
            marginTop: '20px',
        },
        sectionCard: {
            backgroundColor: '#ffffff',
            padding: '25px',
            borderRadius: '16px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
            borderTop: '4px solid #BD06D3',
        },
        sectionTitle: {
            fontSize: '1.25rem',
            fontWeight: '700',
            color: '#0f172a',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        },
        list: {
            listStyle: 'none',
            padding: '0',
            margin: '0',
        },
        listItem: {
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
        },
        link: {
            color: '#475569',
            textDecoration: 'none',
            fontSize: '1rem',
            transition: 'all 0.2s ease',
            cursor: 'pointer',
        },
        bullet: {
            width: '6px',
            height: '6px',
            backgroundColor: '#00BFFF',
            borderRadius: '50%',
            marginRight: '12px',
        }
    };

    const sitemapData = [
        {
            title: "Main Navigation",
            links: ["Home", "Gallery", "Blogs", "Contact Us"]
        },
        {
            title: "About Company",
            links: ["About Us", "Our Management Board", "Our Creative Experts", "Why Choose Us", "Testimonials"]
        },
        {
            title: "Customer Support",
            links: ["Frequently Asked Questions", "Terms & Conditions", "Privacy Policy", "Sitemap"]
        },
        {
            title: "Social Connect",
            links: ["Facebook", "LinkedIn", "Twitter", "YouTube", "Pinterest"]
        }
    ];

    return (
        <div style={styles.pageContainer}>
            {/* Header Banner */}
            <div style={styles.headerBanner}>
                <div style={styles.bannerContent}>
                    <h1 style={styles.mainTitle}>Sitemap</h1>
                    <p style={styles.subTitle}>Iconic Greenland Limited</p>
                </div>
            </div>

            {/* Main Content Container */}
            <div style={styles.wrapper}>
                <p style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 40px auto', color: '#64748b' }}>
                    Find all the sections and pages of Iconic Greenland Limited easily through our structured sitemap.
                    Navigate through our premium property listings and company information.
                </p>

                <div style={styles.gridContainer}>
                    {sitemapData.map((section, index) => (
                        <div key={index} style={styles.sectionCard}>
                            <h2 style={styles.sectionTitle}>
                                <span style={{ color: '#BD06D3' }}>●</span> {section.title}
                            </h2>
                            <ul style={styles.list}>
                                {section.links.map((link, i) => (
                                    <li key={i} style={styles.listItem}>
                                        <div style={styles.bullet}></div>
                                        <a
                                            href={`#${link.toLowerCase().replace(/\s+/g, '-')}`}
                                            style={styles.link}
                                            onMouseOver={(e) => e.target.style.color = '#BD06D3'}
                                            onMouseOut={(e) => e.target.style.color = '#475569'}
                                        >
                                            {link}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Quick Contact Footer of Sitemap */}
                <div style={{ marginTop: '50px', textAlign: 'center', padding: '30px', backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ color: '#0f172a', marginBottom: '10px' }}>Need further assistance?</h3>
                    <p style={{ color: '#64748b' }}>
                        If you can't find what you're looking for, feel free to call our hotline:
                        <strong style={{ color: '#BD06D3' }}> +880 1937-900900</strong>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SiteMap;